module.exports = __webpack_public_path__ + "static/img/2.3027e00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/flags/2.jpg
// module id = 84Lw
// module chunks = 15